import React from 'react';
import SvgIcon48 from '../svgIcon48';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const ShieldIcon = ({ ...others }) => (
  <SvgIcon48
    title="icons / nav / shield"
    {...others}
  >
    <polygon id="Path-2" points="17.9038015 20.7464406 16 22.6619409 22.2993496 29 32 19.9905285 30.173811 18 22.3739793 25.2440876"></polygon>
    <path d="M39.9547882,13.208755 C40.1414624,17.2007344 39.7758369,21.9521133 38.3739356,26.5735757 C36.1454171,33.9200374 31.7119854,39.1238344 24.6126465,40.8513837 L24.0019102,41 L23.3912102,40.8512328 C16.2986632,39.1234804 11.8638434,33.9193113 9.63101491,26.5751359 C8.22302059,21.9439888 7.84993054,17.1085621 8.05025738,13.1971414 L8.14691346,11.3099126 L24.0022383,7 L39.8661025,11.3122338 L39.9547882,13.208755 Z M37.8815701,12.9179714 L24.002304,9.14520585 L10.123038,12.9179714 C9.94676901,16.3596576 9.74750842,35.4005745 24.002304,38.8730587 C38.2724274,35.4005745 38.0425113,16.3596576 37.8815701,12.9179714 Z" id="Shape"></path>
  </SvgIcon48>
);

export default ShieldIcon;
